import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { getAccounts, getSelectedAccount } from '../../../../../../../selectors/tools';
import { Checkbox, CheckBoxColumn, ResultRow, ResultsColumn } from './AccountSearchResultsList.styles';
import { formatDate } from '../../../../../../../util';
import { setSelectedAccount } from '../../../../../../../actions/tools/DecisionTree/accountSearchActions';

const AccountSearchResultsList = () => {
  const accounts = useSelector(getAccounts);
  const selectedAccount = useSelector(getSelectedAccount);
  const dispatch = useDispatch();

  const handleCheckAccount = (account) => {
    dispatch(setSelectedAccount(account));
  };

  if (isEmpty(accounts)) {
    return null;
  }

  return (
    <>
      {accounts.map((account, index) => {
        const isSelected = account.accountId === selectedAccount?.accountId;

        return (
          <ResultRow checked={isSelected} key={account.accountId}>
            <CheckBoxColumn>
              <Checkbox type="radio" checked={isSelected} onChange={() => handleCheckAccount(account)} />
            </CheckBoxColumn>
            <ResultsColumn width="25%">
              <span>{`${account.firstName} ${account.lastName}`}</span>
            </ResultsColumn>
            <ResultsColumn width="25%">
              <span>{account.accountId}</span>
            </ResultsColumn>
            <ResultsColumn width="25%">
              <span>{account.accountType}</span>
            </ResultsColumn>
            <ResultsColumn width="25%">
              <span>{formatDate(account.createdAt)}</span>
            </ResultsColumn>
          </ResultRow>
        );
      })}
    </>
  );
};

export default AccountSearchResultsList;
